import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../api-new/http';
import { fetchTrendingTicketFailure, FetchTrendingTicketRequestAction, fetchTrendingTicketSuccess } from './actions';
import { FETCH_TRENDING_TICKET_REQUEST } from './constants';
import { SagaIterator } from 'redux-saga';
import { sendError } from '../errorHandler';
import { getErrorSetup } from '../../../helpers/getErrorSetup';
import { appUrls } from '../../../api-new/urls';

export function* TradingTicketSaga(action: FetchTrendingTicketRequestAction): SagaIterator {
    try {
        // console.log('Fetching trending ticket...');

        const data = yield call(() =>
            api.get(
                `${appUrls.stockURL}/symbol/trending-ticker/FPT,SSI,VCB,BID,CTG,TCB,VPB,MBB,VHM,VIC,HPG,NVL,MWG,PNJ,PLX,HPX,ACB,TPB,VRE,CTG`,
            ),
        );

        // console.log('Trending Ticket received:', data.data);

        if (data?.data) {
            yield put(fetchTrendingTicketSuccess(data.data));
        }
    } catch (error) {
        yield put(fetchTrendingTicketFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootTrendingTicketSaga(): Generator {
    yield takeLatest(FETCH_TRENDING_TICKET_REQUEST, TradingTicketSaga);
}
